import axios from 'axios';

function wrap(result) {
  return result.then(({ data }) => data)
               .catch(({ data }) => Promise.reject(data));
}

export const getGallery = (params, per_page = 5, items_per_project = 6) => {
  return wrap(axios.get(`/gallery`, { params: { 'per_page': per_page, 'page': params.page || 1, 'items_per_project': items_per_project, q: {...params} } }));
}

export const getProjectGallery = (id, params, per_page = 21) => {
  return wrap(axios.get(`/gallery/${id}`, { params: { 'per_page': per_page, 'page': params.page || 1, q: {...params} } }));
}

export const createGalleryReport = (params) => {
  return wrap(axios.post(`/gallery/reports`, { media_collection: params }));
}

export const getProjects = name => {
  return wrap(axios.get(`/projects`, { params: { q: { customer_name_cont: name } } }));
}

export const getProject = projectId => {
  return wrap(axios.get(`/projects/${projectId}`));
}

export const getActivityMap = projectId => {
    return wrap(axios.get(`/projects/${projectId}/activity_map`));
}

export const deleteProject = projectId => {
  return wrap(axios.delete(`/projects/${projectId}`));
}

export const getProjectGroups = () => {
  return wrap(axios.get('/project_groups'));
}

export const getInsight = (projectId, taskFormId = null, filters = {}) => {

  let newFilters = (Object.keys(filters).length === 0 && filters.constructor === Object) ? null : JSON.stringify(filters);

  if(taskFormId === null && newFilters === null) {
    return wrap(axios.get(`/insights/${projectId}`));
  }
  
  let queryParams = {
    params: {}
  };

  if(taskFormId !== null) {
    queryParams.params.task_form_id = taskFormId;
  }

  if(newFilters !== null) {
    queryParams.params.insight_filter = newFilters;
  }


  return wrap(axios.get(`/insights/${projectId}`, queryParams));
}

export const getInsightFilters = (projectId, taskFormId) => {
  return wrap(axios.get(`/insight_filters`, { params: { q: { task_form_project_id_eq: projectId, task_form_id_eq: taskFormId } } }));
}

export const getInsightFilter = (id) => {
  return wrap(axios.get(`/insight_filters/${id}`));
}

export const createInsightFilter = (values) => {
  return wrap(axios.post(`/insight_filters`, { insight_filter: values }));
}

export const updateInsightFilter = (id, values) => {
  return wrap(axios.patch(`/insight_filters/${id}`, { insight_filter: values }));
}

export const deleteInsightFilter = (id) => {
  return wrap(axios.delete(`/insight_filters/${id}`));
}

export const getCustomColumns = (params) => {
  return wrap(axios.get('/custom_fields', { params: { q: { ...params }} }))
}

export const getProjectGroupSubmissions = (projectGroupId, page, params) => {
  return wrap(axios.get('/submissions', { params: { q: { project_group_id_eq: projectGroupId, ...params }, page }}));
}

export const getSubmission = id => {
  return wrap(axios.get(`/submissions/${id}`));
}

export const getSubmissions = (projectId, page, params) => {
  return wrap(axios.get('/submissions', { params: { q: { project_id_eq: projectId, ...params }, page }}));
}

export const createSubmissionAppeal = (id, values) => {
  return wrap(axios.post(`/submissions/${id}/appeal`, { appeal: values }));
}

export const getTaskForms = (projectId) => {
  return wrap(axios.get(`/projects/${projectId}/task_forms`));
}

export const getTaskForm = (projectId,taskFormId) => {
  return wrap(axios.get(`/projects/${projectId}/task_forms/${taskFormId}`));
}

export const createTaskForm = (values) => {
  return wrap(axios.post(`/projects/${values.project_id}/task_forms`, { task_form: values }));
}

export const updateTaskForm = (values) => {
  return wrap(axios.patch(`/projects/${values.project_id}/task_forms/${values.id}`, { task_form: values }));
}

export const createProject = (values) => {
  return wrap(axios.post('/projects', { project: values }));
}

export const updateProject = (values) => {
  return wrap(axios.patch(`/projects/${values.id}`, { project: values }));
}

export const getRewards = (projectId) => {
  return wrap(axios.get(`/projects/${projectId}/rewards`));
}

export const createReward = (projectId, params) => {
  return wrap(axios.post(`/projects/${projectId}/rewards`, params));
}

export const updateReward = (projectId, params) => {
  return wrap(axios.patch(`/projects/${projectId}/rewards/${params.id}`, params));
}

export const createTask = (projectId, params) => {
  return wrap(axios.post(`/projects/${projectId}/tasks`, {task: params}));
}

export const updateTask = (projectId, taskId, params) => {
  return wrap(axios.patch(`/projects/${projectId}/tasks/${taskId}`, {task: params}));
}

export const currentAccount = () => {
  return wrap(axios.get('/accounts/me'));
}

export const currentAccountLocations = () => {
  return wrap(axios.get('/accounts/me/submission_locations'));
}

export const sendSlackMessage = (message, icon = null) => {
  axios.defaults.headers.common['Authorization'] = "";
  delete axios.defaults.headers.common['Authorization'];
  return wrap(axios.post('https://hooks.slack.com/services/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', JSON.stringify(
    {
      username: "Self Service",
      text: message,
      // channel: '#selfservice-test',
      icon_emoji: icon || ":bidik:"
    }
  )));
}

export const getTargetGroups = (page = 1, per_page = 25) => {
  return wrap(axios.get(`/target_groups?page=${page}&per_page=${per_page}`));
}

export const getTaskFormTemplates = () => {
  return wrap(axios.get(`/task_form_templates`));
}

export const getTaskFormTemplate = (id) => {
  return wrap(axios.get(`/task_form_templates/${id}`));
}

export const getRoles = (id) => {
  return wrap(axios.get(`/customer_roles`));
}

export const searchAreas = value => {
  return wrap(axios.get(`/areas`, { params: { q: { name_like: value } }}));
}

export const getArea = id => {
  return wrap(axios.get(`/areas/${id}`));
}



// WEBPACK FOOTER //
// ./src/api.js